module.exports = __webpack_public_path__ + "img/RCloudFirstUI.a57bc520.png";